/** @jsx dom */
import dom from 'magic-virtual-element';
import {utils as cmsUtils} from '@viskan/cms-components';
import {renderChildren} from '~/streamline-cms/components/section';

const afterUpdate = ({props}, prevProps) => props.linkUrl !== prevProps.linkUrl && props.fetch(props.linkUrl);
const afterMount = ({props}) => !props.data[props.linkUrl] && props.fetch(props.linkUrl);

const render = ({props}) => {
	const content = props.data[props.linkUrl];

	return cmsUtils.createCmsComponent((
		<div class={['CMS-Category-section', props.class, props.styleClasses.Container]} data-style-attr='Container'>
			{props.title && <h1 class={['CMS-Category-title', props.class, props.styleClasses.Title]} data-style-attr='Title'>{props.title}</h1>}
			{content && Boolean(content.length) && <div>{renderChildren(content, props, false)}</div>}
		</div>
	), props);
};

export default {afterMount, afterUpdate, render};
